import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-route-plan-button',
    templateUrl: './route-plan-button.component.html',
    styleUrls: ['./route-plan-button.component.scss'],
    standalone: false
})
export class RoutePlanButtonComponent {
  @Input() title = 'Find';
  @Input() isLoading: boolean;
}
